import { useDelete } from '@refinedev/core';
import { User } from '../types';

type Props = {
  companyId?: string;
};

export function useDeleteUser({ companyId }: Props = {}) {
  const { mutateAsync, error, isLoading, reset } = useDelete<User>();

  const deleteUser = async (id: string) => {
    return mutateAsync({
      resource: companyId ? `admin/companies/${companyId}/users` : 'users',
      id,
    });
  };

  return {
    deleteUser,
    error,
    isLoading,
    reset,
  };
}
